import React from 'react';
import cn from 'classnames';

import { SHARE_CONSTANTS } from 'src/constants/other';
import { share, SocialType } from 'src/utils/share';

import iconFacebook from './assets/icon-fb.svg';
import iconWhatsapp from './assets/icon-whatsapp.svg';
import iconX from './assets/icon-x.svg';

import css from './Socials.module.scss';
import { useSearchParams } from 'react-router-dom';

const SOCIAL_LINKS = [
  {
    id: SHARE_CONSTANTS.X,
    icon: iconX,
  },
  {
    id: SHARE_CONSTANTS.FACEBOOK,
    icon: iconFacebook,
  },
  {
    id: SHARE_CONSTANTS.WHATS_APP,
    icon: iconWhatsapp,
  },
] as const;

export const Socials = ({ className, type }: { className?: string; type: 'general' | 'results' }) => {
  const [searchParams] = useSearchParams();
  const birthDate = searchParams.get('d');

  const onSocialBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const socialType = e.currentTarget.dataset.type as SocialType;

    share({ socialType, ...(type === 'results' && birthDate && { shareData: { d: birthDate } }) });
  };

  return (
    <div className={cn(css.social, className)}>
      {SOCIAL_LINKS.map(({ id, icon }) => (
        <button data-type={id} key={id} className={css.socialLink} onClick={onSocialBtnClick}>
          <img className={css.socialIcon} src={icon} alt="" width={24} height={24} />
        </button>
      ))}
    </div>
  );
};

export default Socials;
